import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { AuthProvider } from './hooks/useAuth';
import { WorkspaceProvider } from './hooks/useWorkspace';
import { NotificationProvider } from './hooks/useNotifications';
import { ThemeProvider } from './hooks/useTheme';
import { ModuleAccessProvider } from './hooks/useModuleAccess';
import { ConfirmProvider } from './components/ConfirmDialog';
import { CartProvider } from './components/CartWidget';

export default function App() {
  return (
    <AuthProvider>
      <WorkspaceProvider>
        <ModuleAccessProvider>
         <ThemeProvider>
          <NotificationProvider>
            {/* In-app confirm() — native window.confirm is a no-op inside the
                iOS WKWebView app, which silently cancelled every delete. */}
            <ConfirmProvider>
              <CartProvider>
                <RouterProvider router={router} />
              </CartProvider>
            </ConfirmProvider>
          </NotificationProvider>
         </ThemeProvider>
        </ModuleAccessProvider>
      </WorkspaceProvider>
    </AuthProvider>
  );
}
